import { Drawer } from "@material-tailwind/react";
import { useState } from "react";
import EditableProfileDetails from "./EditableProfileDetails";
import ProfileDetailsPage from "./ProfileDetails";
import ProfileDetailsV1 from "./ProfileDetailsV1";

const ProfileDrawer = ({ openRight, closeDrawerRight }) => {
  const [isEdit, setIsEdit] = useState(false);

  const handleCloseDrawer = () => {
    setIsEdit(false);
    closeDrawerRight();
  };

  return (
    <Drawer
      placement="right"
      open={openRight}
      onClose={handleCloseDrawer}
      className={` sm:w-[500px] ${
        openRight ? "shadow-xl shadow-debatePalette-base" : ""
      } `}
      overlay={false}
      size={350}
    >
      {!isEdit ? (
        process.env.REACT_APP_FEATURE_FORUM_DEBATES === "true" ? (
          <ProfileDetailsV1
            closeDrawerRight={handleCloseDrawer}
            setIsEdit={setIsEdit}
            enabled={openRight}
          />
        ) : (
          <ProfileDetailsPage
            closeDrawerRight={handleCloseDrawer}
            setIsEdit={setIsEdit}
            enabled={openRight}
          />
        )
      ) : (
        <EditableProfileDetails
          closeDrawerRight={handleCloseDrawer}
          setIsEdit={setIsEdit}
        />
      )}
    </Drawer>
  );
};

export default ProfileDrawer;
